import { ComponentType, useId, useState } from 'react';
import PromptChatContextIndicator, { PromptChatContextButton } from './PromptChatContextIndicator';

type ContextState = { expanded: boolean; contentId: string };
type Options = {
	attributes?: Record<string, string>;
	/** Optional live sources keep their subscriptions inside the preview, not the chat host. */
	Indicator?: ComponentType<ContextState & { onClose: () => void }>;
	Button?: ComponentType<ContextState & { onToggle: () => void }>;
};

/** Shared context composer UI and state for every PromptChat host. */
export default function usePromptChatContext({ attributes = {}, Indicator, Button }: Options = {}) {
	const contentId = useId();
	const [expanded, setExpanded] = useState(false);
	const indicatorProps = { expanded, contentId, onClose: () => setExpanded(false) };
	const buttonProps = { expanded, contentId, onToggle: () => setExpanded(value => !value) };
	return {
		composerContext: Indicator ? <Indicator {...indicatorProps} /> : <PromptChatContextIndicator {...indicatorProps} attributes={attributes} />,
		composerLeadingActions: Button ? <Button {...buttonProps} /> : <PromptChatContextButton {...buttonProps} attributes={attributes} />,
	};
}
